import React, { Component } from "react";
import { Wrapper, Card } from "app/NativeComponents/common";
import { MenuItem } from "app/NativeComponents/snippets";

class PartnerInfo extends Component {
  render() {
    return (
      <Wrapper>
        <Card>
          <MenuItem
            style={{
              borderBottomWidth: 1,
              borderBottomColor: this.props.colors.border_color,
              borderBottomStyle: "solid"
            }}
            to="/a/partner/edit-paypal-email"
            onPress={() =>
              this.props.appRedirect({ redirect: "editPaypalEmail" })
            }
            title="Change Paypal Email"
            text={this.props.partner_info.paypal_email}
          />
          <MenuItem
            to="/a/partner/edit-partner-website"
            onPress={() =>
              this.props.appRedirect({ redirect: "editPartnerWebsite" })
            }
            title="Change Website"
            text={this.props.partner_info.website}
          />
        </Card>
      </Wrapper>
    );
  }
}

export default PartnerInfo;
